import {
    Component,
    OnInit, Injectable, QueryList, ViewChildren, ElementRef, HostListener
} from '@angular/core';
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AppPromptService} from "../../service/app/appPrompt.service";
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {ERROR_CODE} from "../../config/error_code";
import {TIMERS_CONFIG} from "../../config/project";
import {AppVersionService} from "../../service/app-version/appVersion.service";
import {PhoneMaskService} from "../../service/phoneMask.service";
import {AUTH_CODES} from "../../config/auth_codes";
import {environment} from "../../../environments/environment";
import {MainTabsService} from "../../service/main-tabs.service";

const AUTH_TYPE = {
    sms: 'smsPin',
    smsPinPassword: 'smsPinPassword',
    authPin: 'authPin',
    authPinPassword: 'authPinPassword',
    password: 'clintPassword'
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
@Injectable({providedIn: 'root'})
export class LoginComponent implements OnInit {
    pinForm: FormGroup;
    phoneForm: FormGroup;
    registrationForm: FormGroup;

    phoneFormActive = true;
    authCode = null;

    registrationPartActive = false;
    registrationPartStep = 1;
    isRegistrationUpdate = false;
    userRegistrationUpdateData: any;

    isHelpStep = 0;

    phoneLastFour = ' ';
    numOfDigits = 4;
    phoneMask;
    authType = '';

    promoCode;

    @ViewChildren('inputs') inputs: QueryList<ElementRef>;
    constructor(
      private formBuilder: FormBuilder,
      private appVersionService: AppVersionService,
      private authenticationService: AuthenticationService,
      private loaderService: LoaderService,
      private phoneMaskService: PhoneMaskService,
      private router: Router,
      private mainTabsService: MainTabsService,
      private activatedRoute: ActivatedRoute,
      private auth: AuthenticationService,
      private appPromptService: AppPromptService,
      private popupComponent: PopupComponent) {}

    ngOnInit() {
        this.phoneFormInit();
        this.pinFormInit();
        this.registrationFormInit();

        this.phoneMask = this.phoneMaskService.setPhoneMask();

        this.activatedRoute.queryParams.subscribe(params => {
            if (params.promo) {
                this.promoCode = params.promo;
                this.registrationForm.controls.promo.setValue(params.promo);
            }
        });
    }

    phoneFormInit(){
        this.phoneForm = this.formBuilder.group({
            phone: [null, Validators.required]
        });
        this.focusPhoneInput();
    }

    pinFormInit(){
        this.pinForm = this.formBuilder.group({
            digits: this.formBuilder.array([]),
            password: [null, Validators.required],
        });
        for (let i = 0; i < this.numOfDigits; i++) {
            (this.pinForm.get('digits') as FormArray).push(this.formBuilder.control(null, Validators.required))
        }
    }

    registrationFormInit() {
        this.registrationForm = this.formBuilder.group({
            password: [null, Validators.required],
            reEnteredPassword: [null, Validators.required],
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            promo: [null, Validators.required]
        });
    }

    onPhoneSubmit() {
        if (this.phoneForm.controls.phone.invalid) {
            return;
        }

        const phone = this.phoneForm.controls.phone.value;
        const authHash = localStorage.getItem('authHash');

        this.authenticationService.checkPhoneAndSendPin(phone, authHash).subscribe(data => {
            // if (environment.frontEndTest) {
            //     data.status = false;
            //     data.code = AUTH_CODES.showPassword;
            //     data.firstName = "";
            //     data.email = "dkdk@kddk";
            // }
            try {
                if (!data.status) {
                    if (data.code) {
                        if (data.code == AUTH_CODES.registerNewUser) {
                            this.errorHandlerRegisterNewUser();
                        } else if (data.code == AUTH_CODES.showSMSPin) {
                            this.showAuthSecondStep(data.code);
                            this.showSMSLoginStep();
                        } else if (data.code == AUTH_CODES.showAuthPin) {
                            this.showAuthSecondStep(data.code);
                            this.showAuthLoginStep();
                        } else if (data.code == AUTH_CODES.showPassword) {
                            this.showAuthSecondStep(data.code);
                            this.showPasswordLoginStep();
                        } else if (data.code == AUTH_CODES.updateUserInfo) {
                            this.errorHandlerUpdateUserInfo(data);
                        }  else {
                            this.popupComponent.showPopupError({text: data.message});
                        }
                    } else {
                        this.popupComponent.showPopupError({text: data.message});
                    }
                }
            } catch (e) {
                this.loaderService.hideAndShowTryAgain();
            }
        }, (error) => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            setTimeout(() => {
                this.loaderService.hide();
            }, 0);
        });
    }

    showAuthSecondStep(code) {
        this.authCode = code;
        this.phoneFormActive = false;
    }

    showSMSLoginStep() {
        let phone = this.phoneForm.controls.phone.value;
        this.phoneLastFour = phone.substr(-4);

        this.authType = AUTH_TYPE.sms;
        this.focusPinInputs();
    }

    showAuthLoginStep() {
        this.authType = AUTH_TYPE.authPin;
        this.focusPinInputs();
    }

    showPasswordLoginStep() {
        this.authType = AUTH_TYPE.password;
        this.focusPasswordInput();
    }

    errorHandlerRegisterNewUser() {
        this.registrationPartActive = true;
        this.phoneFormActive = false;
        this.authenticationService.accountLoginBtnText();

        this.isRegistrationUpdate = false;
        this.userRegistrationUpdateData = null;
        this.focusPasswordInput();
    }

    errorHandlerUpdateUserInfo(data) {
        this.registrationPartActive = true;
        this.phoneFormActive = false;
        this.authenticationService.accountLoginBtnText();

        this.isRegistrationUpdate = true;
        this.userRegistrationUpdateData = data;
        this.focusPasswordInput();

    }

    onSubmit() {
        const phone = this.phoneForm.controls.phone.value;
        const password = this.isSecondStepPassword() || this.isSecondStepAuthAuthPinPassword() || this.isSecondStepAuthSMSPinPassword() ? this.pinForm.controls.password.value : null;
        const code = this.authCode;
        const authHash = localStorage.getItem('authHash');

        let pin = this.pinForm.controls.digits.value;
        pin = this.isSecondStepAuthSMSPin() || this.isSecondStepAuthAuthPin() || this.isHelpStep ? pin.join('') : null;

        if (this.isHelpStep) {
            if (this.isHelpStep === 2) {
                this.authenticationService.loginSendResetCode(phone, pin).subscribe(data => {
                    try {
                        if (data.status) {
                            this.isHelpStep = 3;
                            this.focusRegistrationPasswordInput();
                        } else {
                            this.popupComponent.showPopupError({text: data.message});
                        }
                    } catch (e) {
                        this.loaderService.hideAndShowTryAgain();
                    }
                }, (error) => {
                    this.loaderService.hideAndShowTryAgain();
                }, () => {
                    this.loaderService.hide();
                });
            } else if (this.isHelpStep === 3) {
                const password = this.registrationForm.controls.password.value;
                this.authenticationService.loginAfterReset(phone, pin, password).subscribe(data => {
                    this.checkLoginSubmit(data);
                }, (error) => {
                    this.loaderService.hideAndShowTryAgain();
                }, () => {
                    this.loaderService.hide();
                });
            }
        } else if (this.registrationPartActive) {
            this.onRegisterNewUser();
        } else {
            this.authenticationService.login(phone, pin, password, code, authHash).subscribe(data => {
                this.checkLoginSubmit(data);
            }, (error) => {
                this.loaderService.hideAndShowTryAgain();
            }, () => {
                this.loaderService.hide();
            });
        }
    }

    checkLoginSubmit(data) {
        try {
            if (data.status) {
                this.isHelpStep = 0;
                this.onCloseTabs();
            } else {
                if (data.code) {
                    if (data.code == ERROR_CODE.blocked || data.code == ERROR_CODE.authOver) {
                        this.popupComponent.showPopupErrorReturnEvent({text: data.message, closePopupAfter: TIMERS_CONFIG.popupHideAfter}, () => {
                            this.logout();
                        })
                    } else {
                        this.popupComponent.showPopupError({text: data.message});
                    }
                } else {
                    this.popupComponent.showPopupError({text: data.message});
                }
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    }

    isPhoneClassActive() {
        return this.phoneFormActive;
    }

    isRegistrationClassActive() {
        return this.registrationPartActive;
    }

    isPinClassActive() {
        return !this.phoneFormActive &&
              (!this.registrationPartActive || (this.registrationPartActive && (this.registrationPartStep === 2)));
    }

    check(index, field, event) {
        if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
            event.preventDefault();
        }

        if (field.value && event.key !== 'Backspace') {
            if (index < this.inputs.toArray().length - 1) {
                this.inputs.toArray()[index + 1].nativeElement.focus();
            }
        } else if (event.key === 'Backspace') {
            if (index > 0) {
                field.setValue(null);
                this.inputs.toArray()[index - 1].nativeElement.focus();
            }
        }
    }

    onRegisterNewUser() {
        const password = this.registrationForm.controls.password.value;

        let pin = this.pinForm.controls.digits.value;
        pin = pin.join('');

        const phone = this.phoneForm.controls.phone.value;
        const firstName = this.registrationForm.controls.firstName.value;
        const lastName = this.registrationForm.controls.lastName.value;
        const promo = this.registrationForm.controls.promo.value;

        if (!this.isRegistrationUpdate) {
            this.authenticationService.register(firstName, lastName, promo, password, phone, pin).subscribe(data => {
                this.checkLoginSubmit(data);
            }, (error) => {
                this.loaderService.hideAndShowTryAgain();
            }, () => {
                this.loaderService.hide();
            });
        } else {
            this.authenticationService.addByPhone(phone, firstName, lastName, password, pin).subscribe(data => {
                this.checkLoginSubmit(data);
            }, (error) => {
                this.loaderService.hideAndShowTryAgain();
            }, () => {
                this.loaderService.hide();
            });
        }

    }

    focusPinInputs() {
        setTimeout(() => {
            this.inputs.toArray()[0].nativeElement.focus();
        }, 0);
    }

    focusPhoneInput() {
        setTimeout(() => {
            (document.querySelector('input[formcontrolname=phone]') as HTMLInputElement).focus();
        });
    }

    focusPasswordInput() {
        setTimeout(() => {
            (document.querySelector('input[formcontrolname=password]') as HTMLInputElement).focus();
        });
    }

    focusRegistrationPasswordInput() {
        setTimeout(() => {
            (document.querySelector('.registration input[formcontrolname=password]') as HTMLInputElement).focus();
        });
    }

    focusFirstNameInput() {
        setTimeout(() => {
            (document.querySelector('input[formcontrolname=firstName]') as HTMLInputElement).focus();
        });
    }

    goBackToLogin() {
        this.phoneFormActive = true;
        this.registrationPartActive = false;
        this.isRegistrationUpdate = false;
        this.userRegistrationUpdateData = null;

        this.authType = '';
        this.authCode = null;
        this.pinForm.reset();
        this.resetPinInput();
    }

    resetPinInput() {
        (this.pinForm.get('digits') as FormArray).clear();
        for (let i = 0; i < this.numOfDigits; i++) {
            (this.pinForm.get('digits') as FormArray).push(this.formBuilder.control(null, Validators.required))
        }
    }

    logout() {
        this.auth.logout();
        this.goBackToLogin();
        this.popupComponent.closePopup();

        if (this.phoneForm) {
            this.phoneForm.controls.phone.setValue(null);
        }else{
            this.phoneFormInit();
        }

        this.resetPinInput();
    }

    isLoginBtnDisabled() {
        return this.phoneForm.controls.phone.invalid;
    }

    isPinLoginBtnDisabled() {
        if (this.isSecondStepAuthAuthPin() || this.isSecondStepAuthSMSPin() || (this.isHelpStep === 2)) {
            return this.pinForm.controls.digits.invalid;
        } else {
            return this.pinForm.controls.password.invalid;
        }
    }

    isSecondStepAuthSMSPin() {
        return this.authType === AUTH_TYPE.sms;
    }

    isSecondStepAuthSMSPinPassword() {
        return this.authType === AUTH_TYPE.smsPinPassword;
    }

    isSecondStepAuthAuthPin() {
        return this.authType === AUTH_TYPE.authPin;
    }

    isSecondStepAuthAuthPinPassword() {
        return this.authType === AUTH_TYPE.authPinPassword;
    }

    isSecondStepPassword() {
        return this.authType === AUTH_TYPE.password;
    }

    onForgotPassword() {
        const phone = this.phoneForm.controls.phone.value;

        this.authenticationService.forgotPassword(phone).subscribe(data => {
            try {
                if (data.status) {
                    this.resetPinInput();
                    this.showHelpSecondStep();
                    this.focusPinInputs();
                } else {
                    this.popupComponent.showPopupError({text: data.message});
                }
            } catch (e) {
                this.loaderService.hideAndShowTryAgain();
            }
        }, (error) => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            this.loaderService.hide();
        });
    }

    toggleInputType() {
        if (this.isSecondStepAuthAuthPin() || this.isSecondStepAuthAuthPinPassword()) {
            this.authType = this.isSecondStepAuthAuthPin() ? AUTH_TYPE.authPinPassword : AUTH_TYPE.authPin;
            this.authCode = this.isSecondStepAuthAuthPin() ? AUTH_CODES.showAuthPin : AUTH_CODES.showPassword;
        } else if (this.isSecondStepAuthSMSPin() || this.isSecondStepAuthSMSPinPassword()) {
            this.authType = this.isSecondStepAuthSMSPin() ? AUTH_TYPE.smsPinPassword : AUTH_TYPE.sms;
            this.authCode = this.isSecondStepAuthSMSPin() ? AUTH_CODES.showSMSPin : AUTH_CODES.showPassword;
        }
        // this.authType = this.isSecondStepAuthAuthPin() ? AUTH_TYPE.authPinPassword : this.isSecondStepAuthAuthPinPassword() ? AUTH_TYPE.authPin :
        //                 this.isSecondStepAuthSMSPin() ? AUTH_TYPE.smsPinPassword : AUTH_TYPE.sms;
        if (this.isSecondStepAuthAuthPinPassword() || this.isSecondStepAuthSMSPinPassword()) {
            this.focusPasswordInput();
        } else {
            this.focusPinInputs();
        }
    }

    onCloseTabs() {
        this.authenticationService.resetLoginBtnText();
        if (this.isHelpStep === 1) {
            this.isHelpStep = 0;
        } else if (this.isHelpStep === 2) {
            this.isHelpStep = 1;
        } else if (this.isHelpStep === 3) {
            this.mainTabsService.resetActiveTab();
            setTimeout(() => {
                this.mainTabsService.makeLoginTabActive();
            })
        } else {
            this.mainTabsService.resetActiveTab();
        }
    }

    showHelp() {
        this.isHelpStep = 1;
        this.authenticationService.helpLoginBtnText();
    }

    showHelpSecondStep() {
        this.isHelpStep = 2;
    }

    onRegistrationNextBtnClick() {
        if (this.isHelpStep === 3) {
            this.onSubmit();
            return;
        }
        if (this.registrationPartStep !== 3) {
            this.registrationPartStep += 1;

            switch (this.registrationPartStep) {
                case 2:
                    this.focusPinInputs();
                    break;
                case 3:
                    this.focusFirstNameInput();
                    break;
            }

        } else {
            this.onRegisterNewUser();
        }
    }

    onRegistrationBackBtnClick() {
        if (this.isHelpStep === 3) {
            this.isHelpStep = 2;
            return;
        }
        if (this.registrationPartStep !== 1) {
            this.registrationPartStep -= 1;
        }
    }

    isRegistrationNextBtnDisabled() {
        return (((this.registrationPartStep === 1) || (this.isHelpStep === 3)) && (!this.registrationForm.controls.password.value || (this.registrationForm.controls.password.value !== this.registrationForm.controls.reEnteredPassword.value))) ||
               ((this.registrationPartStep === 2) && this.pinForm.controls.digits.invalid) ||
               ((this.registrationPartStep === 3) && (!this.registrationForm.controls.firstName.value || !this.registrationForm.controls.lastName.value || (!this.isRegistrationUpdate && !this.registrationForm.controls.promo.value)));
    }
}
